const DNI_REGEX = /^(\d{8})([A-Z])$/
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/

const spainIdType = function(str) {
  if (str.match(DNI_REGEX)) {
    return 'dni'
  }
  if (str.match(CIF_REGEX)) {
    return 'cif'
  }
  if (str.match(NIE_REGEX)) {
    return 'nie'
  }
  return null
}

export const validDNI = function(dni: string): boolean {
  if (!DNI_REGEX.test(dni)) {
    return false
  }
  dni = dni.toUpperCase().replace(/\s/, '')
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE'
  const letter = dniLetters.charAt(parseInt(dni, 10) % 23)
  return letter === dni.charAt(8)
}

export const validNIE = function(nie: string): boolean {
  nie = nie.toUpperCase().replace(/\s/, '')
  // Change the initial letter for the corresponding number and validate as DNI
  let niePrefix = nie.charAt(0)

  switch (niePrefix) {
    case 'X':
      niePrefix = '0'
      break
    case 'Y':
      niePrefix = '1'
      break
    case 'Z':
      niePrefix = '2'
      break
    default:
      niePrefix = 'p'
      break
  }

  return validDNI(niePrefix + nie.substring(1))
}

export const validCIF = function(cif: string): boolean {
  cif = cif.toUpperCase().replace(/\s/, '')
  const match = cif.match(CIF_REGEX)

  const letter = match ? match[1] : null
  const number = match ? match[2] : ''
  const control = match ? match[3] : null

  let evenSum = 0
  let oddSum = 0
  let n = 0

  for (let i = 0; i < number.length; i += 1) {
    n = parseInt(number[i], 10)

    // Odd positions (Even index equals to odd position. i=0 equals first position)
    if (i % 2 === 0) {
      // Odd positions are multiplied first.
      n *= 2

      // If the multiplication is bigger than 10 we need to adjust
      oddSum += n < 10 ? n : n - 9

      // Even positions
      // Just sum them
    } else {
      evenSum += n
    }
  }

  const sum = evenSum + oddSum

  const lastSumDigit = sum % 10

  const controlDigit = lastSumDigit === 0 ? 0 : 10 - lastSumDigit

  const controlLetter = 'JABCDEFGHI'.substring(controlDigit, controlDigit + 1)

  // Control must be a digit
  if (letter?.match(/[ABEH]/)) {
    return String(control) === String(controlDigit)
  }
  // Control must be a letter
  if (letter?.match(/[KPQS]/)) {
    return control === controlLetter
  }
  // Can be either
  return String(control) === String(controlDigit) || String(control) === String(controlLetter)
}

export function validateId(str: string): boolean {
  str = str.toUpperCase().replace(/\s/, '')

  const type = spainIdType(str)

  switch (type) {
    case 'dni':
      return validDNI(str)
    case 'nie':
      return validNIE(str)
    case 'cif':
      return validCIF(str)
    default:
      return false
  }
}

export function validatSWIFTAlphanumeric(value: string): boolean {
  const swiftRegex = /^[a-zA-Z0-9]{1,40}$/
  return swiftRegex.test(value)
}
